/**
 * 배포 버전 확인.
 *
 * SPA 라 한 번 열린 탭은 새로고침하기 전까지 옛 번들로 계속 돈다. 백엔드가 호환되지 않게 바뀌면
 * (2026-09-28 대시보드 API 인증 추가) 배포 전에 열어 둔 탭만 403 을 받는다.
 * 배포할 때 빌드 id 를 /version.json 으로 같이 올리고, 번들에 박힌 id 와 다르면 새 버전이 나온 것이다.
 */

const RELOADED_FOR_KEY = "app-version:reloaded-for";

/** 이 번들이 빌드된 id. 로컬 개발처럼 주입되지 않았으면 빈 문자열(= 확인하지 않음). */
export function getCurrentBuildId(): string {
  return process.env.NEXT_PUBLIC_BUILD_ID || "";
}

/**
 * 지금 배포돼 있는 빌드 id. 알 수 없으면 null.
 * version.json 이 아직 없으면 CDN 이 SPA 폴백(index.html)을 200 으로 주므로 JSON 파싱 실패도 '모름'으로 본다.
 */
export async function fetchLatestBuildId(
  fetcher: typeof fetch = fetch
): Promise<string | null> {
  try {
    const response = await fetcher(`/version.json?t=${Date.now()}`, {
      cache: "no-store",
    });
    if (!response.ok) {
      return null;
    }
    const data = await response.json();
    return typeof data?.buildId === "string" && data.buildId
      ? data.buildId
      : null;
  } catch {
    return null;
  }
}

export function isNewerBuild(current: string, latest: string | null): boolean {
  return Boolean(current) && Boolean(latest) && latest !== current;
}

/**
 * 같은 새 버전에 대해 자동 새로고침은 한 번만 한다.
 * CDN 이 옛 index.html 을 계속 주는 동안에는 새로고침해도 옛 번들이 다시 뜨는데,
 * 이 가드가 없으면 페이지를 옮길 때마다 새로고침된다.
 */
export function canAutoReloadFor(
  latest: string,
  storage: Pick<Storage, "getItem"> = window.sessionStorage
): boolean {
  try {
    return storage.getItem(RELOADED_FOR_KEY) !== latest;
  } catch {
    return false;
  }
}

export function markAutoReloadedFor(
  latest: string,
  storage: Pick<Storage, "setItem"> = window.sessionStorage
): void {
  try {
    storage.setItem(RELOADED_FOR_KEY, latest);
  } catch {
    // 저장소를 못 쓰는 환경(사파리 개인정보 보호 모드 등) — canAutoReloadFor 가 false 라 새로고침하지 않는다.
  }
}
